import React from "react";
import { orderBy } from "lodash";
import { MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { Viewer } from "components/auth/types";
import useSnackbar from "components/haven-design/snackbar/use-snackbar";

const InterestListSelector: React.FC<{
  onListChange: (input: any) => void,
  viewer: Viewer,
  interestListId: string,
}> = ({ onListChange, viewer, interestListId }) => {
  const { openSnackbar } = useSnackbar();
  const handleChange = (e: SelectChangeEvent<string>) => {
    const newListId = e.target.value;
    if (newListId) {
      onListChange(newListId);
      window.location.assign(`/dash/manager/lists/${newListId}`);
    } else {
      openSnackbar({ message: "No list ID selected", status: "error" });
    }
  };

  return (
    <Select
      data-cy="interest-list-selector"
      fullWidth
      margin="dense"
      variant="outlined"
      onChange={handleChange}
      defaultValue={interestListId}>
      {viewer.lists &&
        viewer.lists.length > 1 && (
        <MenuItem value="all">All</MenuItem>
      )}
      {viewer.lists &&
        viewer.lists.length &&
        orderBy(viewer.lists, "name", "asc").map((org, i) => (
          <MenuItem value={org.id} key={i}>
            {org.name}
          </MenuItem>
        ))}
    </Select>
  );
};

export default InterestListSelector;
